export default __webpack_public_path__ + "static/media/aaron.9a099443.png";